@if (loaded) {
  <rt-infobox
    [type]="'warning'"
    [iconName]="'warning'"
    [isDismissible]="false"
    [heading]="'app.settings.delete_company.info_header' | translate"
  >
    <span [innerHTML]="message" class="delete-company-message"></span>&nbsp;<a
      (click)="supportClick.emit()"
      class="support-link"
      >{{ 'app.settings.delete_company.support_team' | translate }}</a
    >
  </rt-infobox>
}
